module.exports = __webpack_public_path__ + "img/image 13.691fbea9.png";